import React from 'react';
import { useApi, apiRequest } from './index';

// Signals Sweeps
export const useSignalsSweeps = (window = '15m', minCount = 3) => {
  return useApi(`/signals/sweeps?window=${window}&minCount=${minCount}`);
};

// Signals Thin Floor
export const useSignalsThinFloor = (pct = 10, maxItems = 20) => {
  return useApi(`/signals/thin-floor?pct=${pct}&maxItems=${maxItems}`);
};

// Price Impact (POST request)
export const usePriceImpact = () => {
  const [data, setData] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(false);
  const [isError, setIsError] = React.useState(false);
  const [error, setError] = React.useState(null);

  const calculateImpact = React.useCallback(async (take) => {
    try {
      setIsLoading(true);
      setIsError(false);
      setError(null);
      
      const result = await apiRequest('/signals/price-impact', {
        method: 'POST',
        body: JSON.stringify({ take }),
      });
      
      setData(result);
    } catch (err) {
      setIsError(true);
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  }, []);

  return {
    data,
    isLoading,
    isError,
    error,
    calculateImpact,
  };
};
